// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    text-align: center;
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  
  /* Styles for the main heading */
  .main-heading {
    font-size: 2.5em;
    margin-bottom: 20px;
    color: #333;
  }`, "",{"version":3,"sources":["webpack://./src/pages/About.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;EAChC;;EAEA,gCAAgC;EAChC;IACE,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb","sourcesContent":[".container {\n    text-align: center;\n    padding: 20px;\n    font-family: Arial, sans-serif;\n  }\n  \n  /* Styles for the main heading */\n  .main-heading {\n    font-size: 2.5em;\n    margin-bottom: 20px;\n    color: #333;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
